<template>
  <div class="container">
    <van-form @submit="onSubmit">
      <div class="info">
        <van-field
          class="require"
          v-model="form.content"
          rows="4"
          autosize
          label="文字说明"
          type="textarea"
          maxlength="1000"
          :rules="rules.content"
          placeholder="请输入"
          show-word-limit
        />
      </div>
      <div class="info">
        <van-field>
          <template #input>
            <div class="upLabel">附件凭证</div>
            <div class="item-info">
              <van-uploader
                class="upload"
                v-model="attachmentList"
                :preview-image="false"
                accept="jpg, .png, .doc, .xls, .pdf"
                :max-count="5"
                :after-read="(file) => afterRead(file, 0)"
              >
                <van-button
                icon="plus"
                size="small"
                type="info"
                  >上传附件</van-button
                >
              </van-uploader>
            </div>
            <div style="font-size: 14px">
              支持jpg .png .doc .xls .pdf等格式，数量最多5个
            </div>
            <div class="item-list">
              <div
                class="list-round"
                v-for="(item, i) in form.attachmentList"
                :key="i"
              >
                <div class="list-title">{{ item.fileName }}</div>
                <van-icon
                  name="cross"
                  @click="fileDel(0, i)"
                />
              </div>
            </div>
          </template>
        </van-field>
      </div>
      <div class="bnt">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          >保存</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import { getLocalStorage } from '@utils'
import {
  uploadFileByContentType
} from '@api/intermediary/index'
import {
  submitContent
} from '@api/market/index'
import { Toast } from 'vant'
export default {
  data() {
    return {
      form: {
        id: '',
        content: '', // 反馈说明
        attachmentList: []
      },
      rules: {
        content: [{ required: true, message: '请填写文字说明' }]
      },
      attachmentList: []
    }
  },
  watch: {
  },
  created() {
    this.form.id = this.$route.query.id
  },
  mounted() {

  },
  methods: {
    afterRead(file) {
      file.status = 'uploading'
      file.message = '上传中...'
      let fd = new FormData()
      fd.append('file', file.file)
      uploadFileByContentType(fd).then((res) => {
        if (res.code === '0000') {
          file.status = 'done'
          this.form.attachmentList.push(res.data)
          this.attachmentList = [
            ...this.form.attachmentList
          ]
          this.$notify({
            type: 'success',
            message: '文件上传成功'
          })
        } else {
          file.status = 'done'
          this.$notify(res.msg || '上传失败')
        }
      })
    },
    fileDel(val, index) {
      this.form.attachmentList.splice(index, 1)
      this.attachmentList.splice(index, 1)
    },
    // 表单提交
    onSubmit() {
      const params = {
        ...this.form
      }
      submitContent(params).then((res) => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.$notify({
            type: 'success',
            message: '保存成功'
          })
          setTimeout(() => {
            this.$router.go(-1)
          }, 500)
        } else {
          Toast(msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  padding-top: 15px;
  min-height: 100vh;
  background: #f7f7f7;
  box-sizing: border-box;
}
.info {
  margin-bottom: 20px;
}
.van-form{
  position: relative;
  height: calc(100vh - 15px);
}
/deep/ .van-field__label {
  white-space: nowrap;
  margin-right: 10px;
  font-size: 16px;
}
.require {
  &:before {
    content: '*';
    color: red;
  }
}
/deep/.van-field__control--custom {
  display: block;
  .upLabel {
    margin-bottom: 6px;
    font-size: 16px;
    span {
      font-size: 14px;
      color: #999;
      margin-left: 10px;
    }
  }
}
/deep/.van-tree-select {
  height: 500px !important;
}
/deep/.van-field__control {
  font-size: 16px;
}
.bnt{
  width: 100%;
  box-sizing: border-box;
  left: 0;
  bottom: 0;
  position: absolute;
  padding: 16px;
  background: white;
}
.item-list {
  width: 100%;
  overflow: hidden;
  .list-round {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    background: #eee;
    padding: 2px 10px;
    box-sizing: border-box;
    margin-bottom: 6px;
    .list-title {
      width: 100px;
      font-size: 12px;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .van-icon {
      display: block;
      margin-left: 10px;
    }
  }
}
</style>
